<template>
  <div class="root">
    <!-- 路由出口 -->
    <router-view></router-view>
  </div>
</template>

<script>
import store from "./store";
import { setItem } from "./utils/storage";
import { isAndroid, isIOS } from "@/utils/index";
export default {
	data() {
		return {};
	},
	created() {
		if (
			process.env.NODE_ENV === "development" &&
      window.location.host === "localhost:8081"
		) {
			setItem("basic", {
				andId        : "6b4fbb39b7939bb2",
				authorization: "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjdmZjM2NzMxLWFjYTgtNDVhNy1hMjNhLTkwNTRlMTA5MDM5ZSJ9.QWCmbai7lUqDrC6DLJ1EAY1_ePIhNbyYmaGi6l6I8HPC8n6tF5tLJhk9mI7c1oCZotM95syA1vgZsT_r8MbZVg",
				clientType   : "app",
				device       : "2",
				deviceId     : "1b6901ad-f7d0-48a4-81a7-30f828dd94d0",
				dramaLang    : "4",
				language     : "4",
				locale       : "id-ID",
				osVersion    : "15",
				pageNum      : 1,
				pageSize     : 10,
				pcgName      : "com.happyshort.tvcn",
				simCountry   : "TH",
				tagLevel     : 2,
				version      : "1.34.0"
			});
			setItem("param", {
				totalMoney : "",
				hasHistory : 1,
				totalReward: "+0 Bonus",
				productId  : "",
				episodeId  : "",
				totalCoin  : "0 Koin"
			});
		}
	},
	methods: {}
};
</script>

<style lang="scss" scoped></style>
